import * as APITypes from "~/API";
import { getLeaseList, getTenantInfo } from "~/services/server";
import { getOfferInfo } from "~/services/server/lease/getLeaseInfo";
import { LoaderData } from "~/types";
import { FormattedActiveLeaseData } from "~/types/unit";

export const getActiveLeaseInfo = async ({
  unitID,
  ownerID,
  ownerType,
}: {
  unitID: string;
  ownerID: string;
  ownerType: APITypes.OwnerType;
}): Promise<LoaderData<FormattedActiveLeaseData | null>> => {
  const leases = await getLeaseList({
    entityType: APITypes.EntityType.Unit,
    entityID: unitID,
    ownerID,
    ownerType,
    status: APITypes.LeaseStatusType.Active,
  });
  if (!leases.success) {
    return {
      success: false,
      data: null,
      error: leases.error,
    };
  }

  if (leases.data.length === 0) {
    return {
      success: true,
      data: null,
    };
  }

  if (leases.data.length > 1) {
    return {
      success: false,
      data: null,
      error: new Error("Too many active leases found"),
    };
  }

  const activeLease = leases.data[0];
  const tenantInfo = await getTenantInfo({
    tenantID: activeLease.tenantID || "",
  });
  if (!tenantInfo.success) {
    return {
      success: false,
      data: null,
      error: tenantInfo.error,
    };
  }
  const tenant = tenantInfo.data;

  // Fetch offer to get rent if offerID exists
  let rent: number | undefined = undefined;
  if (activeLease.offerID) {
    const offerInfo = await getOfferInfo(activeLease.offerID);
    if (offerInfo.success && offerInfo.data) {
      rent = offerInfo.data.rent;
    }
  }

  return {
    success: true,
    data: {
      leaseInfo: activeLease,
      tenantInfo: tenant,
      rent,
    },
  };
};
